import { Trigger } from '@radix-ui/react-dropdown-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface DropdownMenuTriggerProps extends ComponentPropsWithoutRef<
  typeof Trigger
> {
  asChild?: boolean
  /**
   * Data attributes:
   * [data-state] - "open" | "closed"
   * [data-disabled] - Present when disabled
   */
  className?: string
  children: ReactNode
}

export const DropdownMenuTrigger = Trigger
